var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEconomic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100.335,
    viewBox: "0 0 100 100.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dda9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04a8e7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-growth",
    transform: "translate(0.359 0.094)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 100,
    height: 100,
    transform: "translate(-0.359 -0.094)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M28.6,30.846H25.483a3.122,3.122,0,0,0-3.121-3.121v0A9.362,9.362,0,0,1,13,18.363h0A9.362,9.362,0,0,1,22.362,9H28.6a3.121,3.121,0,0,1,0,6.242H22.362a3.122,3.122,0,0,0-3.121,3.121h0a3.122,3.122,0,0,0,3.121,3.121v0a9.362,9.362,0,0,1,9.362,9.362h0a9.362,9.362,0,0,1-9.362,9.362H16.121a3.121,3.121,0,0,1,0-6.242h6.242a3.122,3.122,0,0,0,3.121-3.121Zm0,0h0Z",
    transform: "translate(27.57 41.308)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M15,10.121v6.242a3.121,3.121,0,1,0,6.242,0V10.121a3.121,3.121,0,1,0-6.242,0Zm6.242,37.45V41.329a3.121,3.121,0,1,0-6.242,0v6.242a3.121,3.121,0,1,0,6.242,0Z",
    transform: "translate(31.812 37.066)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M42.218,4.556A34.329,34.329,0,1,0,76.546,38.885,34.345,34.345,0,0,0,42.218,4.556Zm0,6.242A28.087,28.087,0,1,1,14.13,38.885,28.1,28.1,0,0,1,42.218,10.8Z",
    transform: "translate(7.715 27.027)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M15,75.622V97.468a3.121,3.121,0,1,0,6.242,0V75.622a3.121,3.121,0,1,0-6.242,0Z",
    transform: "translate(31.812 -62.764)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M18.515,5.016c-4.385,4.385-4.61,10.837-1.1,14.344s9.959,3.281,14.344-1.1,4.61-10.837,1.1-14.344S22.9.631,18.515,5.016Zm4.413,4.414c1.715-1.715,4.144-2.476,5.517-1.1s.611,3.8-1.1,5.517-4.144,2.476-5.517,1.1S21.214,11.144,22.929,9.429Z",
    transform: "translate(31.776 3.521)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M27.256,3.543c-4.385-4.385-10.837-4.61-14.344-1.1s-3.281,9.959,1.1,14.344,10.837,4.61,14.344,1.1S31.64,7.928,27.256,3.543ZM22.842,7.956c1.715,1.715,2.476,4.144,1.1,5.517s-3.8.611-5.517-1.1-2.476-4.144-1.1-5.517S21.128,6.242,22.842,7.956Z",
    transform: "translate(22.233 0.398)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomic);
export default __webpack_public_path__ + "static/media/economic.83ad8682fb108f76dd130684c3822ecf.svg";
export { ForwardRef as ReactComponent };